$(document).ready(function() {

	 // This is not a touch screen device
	// if (!('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0)) {

		// Spotlight cursor

		const cursor = document.querySelector("#cursor");
		const cursorBorder = document.querySelector("#cursor-border");
		const cursorPos = { x: 0, y: 0 };
		const cursorBorderPos = { x: 0, y: 0 };

		document.addEventListener("mousemove", (e) => {
			cursorPos.x = e.clientX;
			cursorPos.y = e.clientY;

			cursor.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
		});

		requestAnimationFrame(function loop() {
			const easting = 8;
			cursorBorderPos.x += (cursorPos.x - cursorBorderPos.x) / easting;
			cursorBorderPos.y += (cursorPos.y - cursorBorderPos.y) / easting;

			cursorBorder.style.transform = `translate(${cursorBorderPos.x}px, ${cursorBorderPos.y}px)`;
			requestAnimationFrame(loop);
		});


		// Define the array of selectors
		const selectors = [
			"a",
			"button",
			".burger-menu .menu-icon",
			".btn",
			".marquee-pic",
			".swiper-button",
			".video-wrap",
			".map-nav .child-item__title",
			".map-nav .parent-item:not(.js-active) .parent-item__title",
			".map-nav .child-item__content .icon-close",
			".country-map-nav .child-item__title",
			".country-map-nav .parent-item:not(.js-active) .parent-item__title",
			".country-map-nav .child-item__content .icon-close",
			".sf-field-submit *"
		];

		// Join the selectors into a single string
		const selectorString = selectors.join(", ");

		document.querySelectorAll(selectorString).forEach((item) => {
			item.addEventListener("mouseover", (e) => {
				// cursor.style.backgroundColor = "yellow";
				cursorBorder.style.backgroundColor = "white";
			// cursorBorder.style.mixBlendMode = "difference";
				cursorBorder.style.setProperty("--size", "60px");
			// console.log("Mouse over:", e.target);
			});
			item.addEventListener("mouseout", (e) => {
				// cursor.style.backgroundColor = "white";
				cursorBorder.style.backgroundColor = "unset";
				// cursorBorder.style.mixBlendMode = "unset";
				cursorBorder.style.setProperty("--size", "30px");
			});
		});

	// }

	
});